import { InjectionToken } from "@angular/core";
import { EmploymentContractsPort } from "./employment-contracts.port";

export const EMPLOYMENT_CONTRACTS_PORT =
  new InjectionToken<EmploymentContractsPort>("EMPLOYMENT_CONTRACTS_PORT");
